import { isObject } from 'vessel/utils'

function coerce(propValue, callback) {
  let computed = propValue

  if (isObject(propValue)) {
    computed = Object.entries(propValue).reduce((result, [key, value]) => {
      result[key] = coerce(value, callback)
      return result
    }, {})
  } else {
    computed = callback(propValue)
  }

  return computed
}

export default coerce
